module.exports = __webpack_public_path__ + "assets/images/ert1.2b226c12acbcab95434e38e7b7a8d439.png";